import { CIcon } from '~/icons/types'

export const ciAuditRequest: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm21.929 19.313-2.568-2.164a6.148 6.148 0 0 0 .514-2.462 6.189 6.189 0 0 0-3.387-5.51c-.05-1.098-.352-1.736-.863-2.274.26-.167.435-.43.435-.756 0-.536-.442-.94-1.028-.94h-.53l-.938-2.228a2.293 2.293 0 0 0-2.143-1.469l-4.78.004c-.881-.113-1.792.46-2.285 1.446l-.945 2.247H2.88c-.586 0-1.028.404-1.028.94 0 .348.198.627.49.79-.539.584-.842 1.342-.842 2.206v2.202c0 .22.145.408.352.473v1.877c0 .728.558 1.32 1.243 1.32H4.25c.686 0 1.243-.593 1.243-1.318l.004-1.06h2.359a6.168 6.168 0 0 0-.356 2.051 6.195 6.195 0 0 0 6.188 6.188 6.15 6.15 0 0 0 3.442-1.049c.01.011.014.025.025.035l2.188 2.1c.361.36.835.54 1.309.54s.948-.18 1.309-.54c.72-.724.72-1.898-.032-2.649ZM5.265 3.378c.281-.562.811-.928 1.314-.868h4.843c.528 0 1.024.337 1.211.838l1.155 2.742H4.124l1.141-2.712ZM4.25 14.014H3.095c-.134 0-.243-.144-.243-.319v-1.628l1.646.4-.005 1.227c.001.176-.108.32-.243.32Zm1.068-2.377L2.5 10.952V9.73h1.613a.5.5 0 0 0 0-1h-1.57a2.134 2.134 0 0 1 .826-1.398l.303-.242h10.656l.29.231c.416.357.717.684.83 1.438a6.161 6.161 0 0 0-1.76-.259 6.185 6.185 0 0 0-5.376 3.137H5.318ZM8.5 14.688A5.194 5.194 0 0 1 13.688 9.5a5.193 5.193 0 0 1 5.188 5.188 5.193 5.193 0 0 1-5.188 5.188A5.194 5.194 0 0 1 8.5 14.688Zm12.753 6.565a.854.854 0 0 1-1.211-.008L17.909 19.2c.366-.343.692-.728.966-1.15l2.378 2.001a.853.853 0 0 1 0 1.203Z',
      fill: 'currentColor'
    },
    {
      d:
        'm15.116 13.18-2.115 2.537-1.116-1.349a.499.499 0 1 0-.77.637l1.5 1.813a.496.496 0 0 0 .384.181H13a.497.497 0 0 0 .384-.18l2.5-3a.5.5 0 0 0-.768-.64Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'audit-request',
  type: 'thin',
  fill: 'none'
}
